import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DmsUser, type UpdateUserParams } from "../../../domain/entities/user";
import { type UsersDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const updateUser = createAsyncThunk<
  DmsUser,
  UpdateUserParams,
  { dispatch: UsersDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UPDATE_USER, async (params, { extra }) => {
  return await extra.usersRepo.updateUser(params);
});
